import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom, Container, TextArea, Static } from '@app/shared';
import { Validators } from '@angular/forms';
import { find } from 'lodash';

@Injectable()
export class DocumentAssessmentFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para agregar o modificar la valoracion de un documento
   *
   * @param {TemplateRef<any>} templateUpload
   * @returns {BaseControl<any>[]}
   * @memberof DocumentAssessmentFormService
   */
  getFormDocumentAssessment(
    templetesFomr: any,
    objectModel: any,
    data: any
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'serie',
        label: 'Serie',
        value: objectModel ? objectModel.serie ? objectModel.serie.id : null : null, 
        size: 'col-12 col-lg-12',
        options: data ? data['serie']: [],
        template: templetesFomr['serie'],
        placeholder: 'Seleccione la serie',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'subserie',
        label: 'Subserie',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.subserie ? objectModel.subserie.id : null : null, 
        template: templetesFomr['subserie'],
        options: data ? data['subserie'] : [],
        placeholder: 'Seleccione la subserie',
        validations: {
          validators: []
        },
        condictions: [
          {
            campoDepende: 'serie',
            siEs: 'Vacio',
            accion: 'Bloquear'
          }
        ]
      }),
      // new Custom({
      //   key: 'tipo_documental',
      //   label: 'Tipo documental',
      //   size: 'col-12 col-lg-12',
      //   value: objectModel ? objectModel.tipo_documental ? objectModel.tipo_documental.id : null : null, 
      //   template: templetesFomr['tipo_documental'],
      //   options: data ? data['tipo_documental'] : [],
      //   placeholder: 'Seleccione el tipo documental',
      //   validations: {
      //     validators: []
      //   },
      //   condictions: [
      //     {
      //       campoDepende: 'subserie',
      //       siEs: 'Vacio',
      //       accion: 'Bloquear'
      //     }
      //   ]
      // }),
      new Custom({
        key: 'soporte',
        label: 'Soporte',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.soporte ? objectModel.soporte.id : null : null, 
        template: templetesFomr['select'],
        options: data ? data['soporte'] : [],
        placeholder: 'Seleccione el soporte de documento',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'ag',
        label: 'AG (Archivo de gestión)',
        type: 'number',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.ag : null,
        customDecimalMax: 0,
        customMin: 0,
        placeholder: 'Ingrese el número de años',
        validations: {
          validators: [Validators.required, Validators.pattern(/^\d*$/), Validators.min(1)],
          messages: {
            pattern: 'Caracteres incorrectos. Solo puede ingresar números enteros.',
            min: 'Debe ingresar un número mayor a 0.'
          }
        }
      }),
      new Textbox({
        key: 'ac',
        label: 'AC (Archivo central)',
        type: 'number',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.ac : null,
        customDecimalMax: 0,
        customMin: 0,
        placeholder: 'Ingrese el número de años',
        validations: {
          validators: [Validators.required, Validators.pattern(/^\d*$/), Validators.min(1)],
          messages: {
            pattern: 'Caracteres incorrectos. Solo puede ingresar números enteros.',
            min: 'Debe ingresar un número mayor a 0.'
          }
        }
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          new Textbox({
            key: 'ct',
            label: 'CT (Conservación total)',
            type: 'checkbox',
            order: 2,
            value: objectModel ? objectModel.ct : false,
            placeholder: 'Ingrese el valor CT',
            size: 'col-md-2',
            condictions: [
              {
                campoDepende: 'e',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
              {
                campoDepende: 's',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
            ]
          }),
          new Textbox({
            key: 'e',
            label: 'E (Eliminación)',
            type: 'checkbox',
            order: 3,
            value: objectModel ? objectModel.e : false,
            placeholder: 'Ingrese el valor E',
            size: 'col-md-2',
            condictions: [
              {
                campoDepende: 'ct',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
              {
                campoDepende: 's',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
            ]
          }),
          new Textbox({
            key: 'md',
            label: 'MD (Microfilmación / Digitalización)',
            type: 'checkbox',
            order: 4,
            value: objectModel ? objectModel.md : false,
            placeholder: 'Ingrese el valor MD',
            size: 'col-md-2',
            condictions: [
              {
                campoDepende: 'soporte',
                siEs: 'Igual',
                valor: 2,
                accion: 'Ocultar'
              }
            ]
          }),
          new Textbox({
            key: 's',
            label: 'S (Selección)',
            type: 'checkbox',
            order: 5,
            value:  objectModel ? objectModel.s : false,
            placeholder: 'Ingrese el valor S',
            size: 'col-md-2',
            condictions: [
              {
                campoDepende: 'ct',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
              {
                campoDepende: 'e',
                siEs: 'Igual',
                valor: true,
                accion: 'Bloquear'
              },
            ]
          }),
        ]
      }),
      new TextArea({
        key: 'procedimiento',
        label: 'Procedimiento',
        value:  objectModel ? objectModel.procedimiento : null,
        placeholder: 'Ingrese el procedimiento',
        size: 'col-md-12'
      }),
    ];
    

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/documentary-assessment/shared/documentary-assessment-form.service.ts